export default __webpack_public_path__ + "static/media/Harness of Bestial Rage.a4f40394.jpg";